import { Field, Form, Formik } from 'formik'
import type { ReactNode } from 'react'
import React, { useState } from 'react'

import { Button, ButtonClean, ButtonGroup, Dropdown, Input } from '@fourthwall/components'

import * as S from './QuantityDropdown.styled'
import type { FormValues } from './QuantityDropdown.types'
import { getValidationSchema } from './consts'

export type QuantityDropdownProps = {
  title: string
  description?: ReactNode
  quantity: string
  disabled?: boolean
  maxValue?: number
  onSubmit: (value: string) => void
}

export const QuantityDropdown = ({
  title,
  description,
  disabled,
  quantity,
  maxValue,
  onSubmit,
}: QuantityDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const initialValues: FormValues = {
    quantity: parseInt(quantity),
  }

  const handleClose = () => setIsOpen(false)

  const handleSubmit = (values: FormValues) => {
    onSubmit(values.quantity.toString())
    handleClose()
  }

  return (
    <Dropdown
      isOpen={isOpen}
      content={
        <Formik<FormValues>
          initialValues={initialValues}
          validationSchema={getValidationSchema(maxValue)}
          onSubmit={handleSubmit}
        >
          {({ submitForm }) => (
            <Form>
              <S.Container>
                <S.Heading>
                  <div>{title}</div>
                  {description && <S.Description>{description}</S.Description>}
                </S.Heading>

                <Field
                  name="quantity"
                  component={Input}
                  type="number"
                  size="large"
                  fullWidth
                  label="Quantity"
                  min={1}
                  max={maxValue}
                  disabled={disabled}
                />

                <ButtonGroup direction="column" fullWidth space="medium">
                  <Button
                    type="submit"
                    appearance="primary"
                    label="Save"
                    fullWidth
                    onClick={submitForm}
                  />
                  <Button appearance="secondary" label="Cancel" fullWidth onClick={handleClose} />
                </ButtonGroup>
              </S.Container>
            </Form>
          )}
        </Formik>
      }
      onClose={handleClose}
    >
      <ButtonClean label={quantity} onClick={() => setIsOpen(true)} />
    </Dropdown>
  )
}
